import { SImage } from './Image.styles';
import { ImageProps } from './Image.types';

export const Image = ({ ...props }: ImageProps) => {
  return <SImage {...props} />;
};
